import React from "react"

import { ErrorBoundaryProps } from "./ErrorBoundary.types"

import styles from "./ErrorBoundary.module.scss"

const ErrorBoundary: React.FC<ErrorBoundaryProps> = (props) => {
  const { error } = props

  return (
    <div style={{ padding: "40px", width: "80vw", wordBreak: "break-word" }}>
      An Error Appeared: {JSON.stringify(error, Object.getOwnPropertyNames(error))}
    </div>
  )
}

export default ErrorBoundary
